// Latvian interface copy and faithful display translations of existing reviews.
// Judge.me's stored reviews and the English storefront remain unchanged.
(() => {
  if (document.documentElement.lang.split('-')[0] !== 'lv') return;
  const translations = [
  {
    "id": "504cc2fa-4996-427b-9954-6b3d042eef53",
    "original": "Been using this for few months, my urticaria (nātrene) is wayyy better and easier to manage. Also my overall health is a lot better. I rarely get colds and haven't had any cold sores since using this. Can't recommend enough. And thank God for subscribe and save option, I don't have to remember to order manually. Thank you, Ilze 🙏",
    "latvian": "Lietoju šo produktu jau dažus mēnešus. Mana nātrene ir ievērojami mazinājusies, un to ir vieglāk kontrolēt. Arī mana vispārējā veselība ir daudz labāka. Es reti saaukstējos, un kopš šī produkta lietošanas man nav bijušas aukstumpumpas. Nevaru vien beigt to ieteikt! Un labi, ka ir iespēja abonēt un ietaupīt — man nav jāatceras katru reizi veikt pasūtījumu. Paldies, Ilze! 🙏"
  },
  {
    "id": "cb6970fc-24ca-4b49-b694-d31d1fe9db38",
    "original": "Love this products, it works!",
    "latvian": "Man patīk šie produkti — tie darbojas!"
  },
  {
    "id": "65b27bbd-2dae-4e7b-8a11-9227136a40f7",
    "original": "Very fast shipping, really nice owners - helps choosing the products and answers all the questions. Very nicely packaged. You can see everything is authentic, homemade and made with love 🙏🏼",
    "latvian": "Ļoti ātra piegāde un patiešām jauki saimnieki — palīdz izvēlēties produktus un atbild uz visiem jautājumiem. Viss ir ļoti glīti iepakots. Var redzēt, ka viss ir autentisks, mājās gatavots un radīts ar mīlestību. 🙏🏼"
  },
  {
    "id": "7a98d3c0-68dc-4bfc-b1e1-36958a4e31cb",
    "original": "Very good tea. Helps to get better quicker 💪🏼",
    "latvian": "Ļoti laba tēja. Palīdz ātrāk atveseļoties. 💪🏼"
  }
];
  const interfaceCopy = window.motionReviewInterface || {};
  const phrases = new Map([
    ['Klienti mums sako', 'Ko saka mūsu klienti'],
    ['Tikras klientu stāstības', 'Mūsu klientu pieredzes stāsti'],
    ['Šis veikals vēl netiek atsaukt', 'Šim veikalam vēl nav atsauksmju'],
    ['Šis produkts vēl netiek atsaukt', 'Šim produktam vēl nav atsauksmju'],
    ['Customer reviews', 'Klientu atsauksmes'],
    ['Previous reviews', 'Iepriekšējās atsauksmes'],
    ['Next reviews', 'Nākamās atsauksmes'],
  ]);
  const processed = new WeakSet();
  const normalize = value => value.replace(/\s+/g, ' ').trim();
  function update() {
    if (window.jdgmSettings) Object.assign(window.jdgmSettings, interfaceCopy);
    document.querySelectorAll('.jdgm-widget').forEach(widget => {
      const walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const text = node.textContent.trim();
        if (phrases.has(text)) node.textContent = phrases.get(text);
      }
      widget.querySelectorAll('[aria-label]').forEach(element => {
        const text = element.getAttribute('aria-label');
        if (phrases.has(text)) element.setAttribute('aria-label', phrases.get(text));
      });
    });
    document.querySelectorAll('.jdgm-testimonial[data-review-id], .jdgm-rev[data-review-id]').forEach(card => {
      const body = card.querySelector('.jdgm-text, .jdgm-rev__body');
      if (!body || processed.has(body)) return;
      const review = translations.find(item => item.id === card.dataset.reviewId);
      if (!review || normalize(body.textContent) !== normalize(review.original)) return;
      processed.add(body);
      const original = Array.from(body.childNodes, node => node.cloneNode(true));
      const controls = document.createElement('div');
      controls.className = 'motion-review-translation';
      const note = document.createElement('small');
      note.textContent = 'Tulkojums no angļu valodas';
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'link underlined-link';
      let translated = true;
      function render() {
        if (translated) {
          const paragraph = document.createElement('p');
          paragraph.textContent = review.latvian;
          body.replaceChildren(paragraph);
        } else body.replaceChildren(...original.map(node => node.cloneNode(true)));
        note.textContent = translated ? 'Tulkojums no angļu valodas' : 'Oriģināls angļu valodā';
        toggle.textContent = translated ? 'Rādīt oriģinālu' : 'Rādīt tulkojumu';
      }
      toggle.addEventListener('click', event => {
        event.stopPropagation();
        translated = !translated;
        render();
      });
      controls.append(note, toggle);
      body.after(controls);
      render();
    });
  }
  // Settings are patched as soon as the app inserts them; DOM work is batched.
  let queued = false;
  new MutationObserver(() => {
    if (window.jdgmSettings) Object.assign(window.jdgmSettings, interfaceCopy);
    if (!queued) {
      queued = true;
      requestAnimationFrame(() => { queued = false; update(); });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  update();
})();
